import CreateColumn from '../../../../../Services/agGrid/createColumn';
import { Button as GridButton } from '../../../../../Components/MUIs';
import { CloudUpload as CloudUploadIcon } from '@mui/icons-material';

/** 조직 고정 컬럼(본부·부서·팀·파트) — TRA_NEW_05 읽기전용 셀과 동일 */
const ReadOnlyOrgColumnExtra = {
  flex: 1,
  cellClass: 'read-only-italic-cell',
  customCellStyle: {
    backgroundColor: '#f5f5f5',
    color: '#666',
    fontStyle: 'italic',
    cursor: 'not-allowed',
  },
};

export const getColumnDefs1 = (props) => {
  return [
    CreateColumn('no', 'NO', 'right', 80, false, false, false, 'checkbox'),
    CreateColumn('depNm1', '본부', 'left', 120, false, false, false, 'text', {
      ...ReadOnlyOrgColumnExtra,
    }),
    CreateColumn('depNm2', '부서', 'left', 120, false, false, false, 'text', {
      ...ReadOnlyOrgColumnExtra,
    }),
    CreateColumn('depNm3', '팀', 'left', 120, false, false, false, 'text', {
      ...ReadOnlyOrgColumnExtra,
    }),
    CreateColumn('depNm4', '파트', 'left', 120, false, false, false, 'text', {
      ...ReadOnlyOrgColumnExtra,
    }),

    CreateColumn(
      'fileUpload',
      '파일 업로드',
      'center',
      150,
      false,
      false,
      false,
      'button',
      {
        pinned: 'right',
        buttonRenderer: (e) => (
          <GridButton
            startIcon={<CloudUploadIcon />}
            size="small"
            variant="contained"
            name={'업로드'}
            sx={{
              width: '100%',
              backgroundColor: '#7e57c2',
              color: '#fff',
              '&:hover': {
                backgroundColor: '#5e35b1',
              },
            }}
            onClick={() => {
              props.PopupClickEvent1(e.data, 'edu');
            }}
          />
        ),
      }
    ),

    CreateColumn('createId', '작성자', 'left', 100, false, false, true),
    CreateColumn('mapBlob', '블롭', 'left', 100, false, false, true),
    CreateColumn('mapFile', '파일', 'left', 100, false, false, true),
    CreateColumn(
      'mapFileName',
      '파일명(사용자가 올린 이름)',
      'left',
      150,
      false,
      false,
      true
    ),
    CreateColumn(
      'saveName',
      '파일명(저장되는 이름)',
      'left',
      100,
      false,
      false,
      true
    ),
    CreateColumn(
      'previewFilePath',
      '미리보기 주소',
      'left',
      100,
      false,
      false,
      true
    ),
  ];
};

const columnDefs = {
  getColumnDefs1,
};

export default columnDefs;
